/**
 *
 * @author Matthew Rawson @ 13/09/2018 11:46
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {get} from "lodash"

import id from "@irati/utils/id/index"
import {injectIntl} from "@irati/utils/lang/index"
import padding from "@irati/ui/src/global/padding"

import {formatDriverName} from "@irati/insights/utils/string"
import {Para} from "../../ui/Labels/index"
import {Image} from "../../ui/Image/index"
import helper from "../../helpers/DriverIcon/index"


const Cell = styled.div`
  display: flex;
  align-items: center;
`
const WrappedPara = styled(Para)`
  white-space: normal;
`

const SpacedImage = styled(Image)`
  margin-right: ${padding.tiny};
`


class DriverCellRenderer extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    row: PropTypes.object,
    accessor: PropTypes.string
  }
  static defaultProps = {
    row: {},
    accessor: "driver"
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("DriverCellRenderer", this.props)
    const {row, accessor, formatMessage} = this.props
    const contentId = get(row, `${accessor}.contentId`) || "insights.driver.allDrivers"
    const driverName = formatDriverName(formatMessage, {contentId})

    return (
      <Cell id={idNamespace} {...this.props}>
        <SpacedImage src={helper.getDriverIcon(contentId)} alt="" size={45} />
        <WrappedPara medium flush>
          {driverName}
        </WrappedPara>
      </Cell>
    )
  }
}

export default injectIntl(DriverCellRenderer)
